import React from 'react';
/* eslint-disable react/prop-types */
// -*- mode: jsx;-*-
// Defined in general.js
/* global createCookie */

import { getS3ProfilePhotoURL } from '../utils/userUtils.js';
import { FavoriteHeart } from '../common/favoriteHeart.js';

let Teacher = ({
    xCoord,
    yCoord,
    teacherName,
    cropWidth,
    photoPath,
    photoDate,
    smartCrop,
    searchURL,
    teacherId,
    cropHeight,
    photoPublished,
    photoType,
    stateCode,
    callbacks,
    cityName,
    schoolName,
    preFastlyImage,
    favoriteTeacherIds,
}) => {
    function onClick() {
        createCookie('searchedForTeacher', teacherId, 1);
    }

    const isFavorite = !!favoriteTeacherIds && favoriteTeacherIds.indexOf(teacherId) > -1;
    const teacherLink = baseURL + 'classroom/' + teacherId;
    // 68x68 is the size of the smallest teacher profile photo (legacy)
    const teacherImage = getS3ProfilePhotoURL(
        photoPublished, photoType, teacherId, photoDate,
        photoPath, 68, baseCacheURL, baseS3URL,
        preFastlyImage, smartCrop, xCoord, yCoord, cropWidth, cropHeight);

    return (
        <div className="teacher">
            <a onClick={onClick} href={teacherLink}>
                <img src={teacherImage} className="teacher-photo" alt="Teacher" width="50px" height="50px" />
                <div className="teacher-info">
                    <div className="teacher-name">{teacherName}</div>
                    <div className="secondary-info">
                        <p>{schoolName}</p>
                        <p>{cityName}, {stateCode}</p>
                    </div>
                </div>
            </a>
            <div className="teacher-favorite-holder">

                <FavoriteHeart favoriteType="teacherId" favoriteValue={teacherId}
                               loadFavorites={callbacks.loadFavorites}
                               isFavorite={isFavorite} trackingName="Follow-teacher" pageURL={searchURL}
                                additionalButtonClasses="button-secondary long small active"
                               additionalDescriptorText="Follow this teacher to hear about relevant projects."
                               formDivClassName="followEmailHolder subnav save-search-popup"
                               buttonText="Follow teacher"/>
            </div>
        </div>
    );
};
Teacher = React.memo(Teacher);
export default Teacher;
